const userStatuses = {
  pending: 'Pending',
  active: 'Active',
  locked: 'Locked',
};

export default userStatuses;
